import { Modal } from 'bootstrap';

/**
 * The switch of the period in the shop (app/UI/Modules/Subscription/templates/Plan/default.latte). All prices are in
 * the page, the switch only shows those of the chosen period; a card of a plan without the period is hidden.
 * The detail of a plan is a dialog of the page too.
 */
export function registerShopPage(snippet: HTMLElement): void {
    snippet.querySelectorAll<HTMLElement>('[data-shop]').forEach(shop => {
        if (shop.dataset.shopInitialized === '1') {
            return;
        }
        shop.dataset.shopInitialized = '1';

        shop.querySelectorAll<HTMLButtonElement>('[data-shop-period]').forEach(button => {
            button.addEventListener('click', () => selectPeriod(shop, button.dataset.shopPeriod ?? ''));
        });

        // the order opens its own dialog in place of the detail of the plan
        shop.querySelectorAll<HTMLElement>('[data-shop-detail]').forEach(detail => {
            detail.querySelectorAll<HTMLElement>('[data-shop-detail-order]').forEach(link => {
                link.addEventListener('click', () => Modal.getOrCreateInstance(detail).hide());
            });
        });
    });
}

function selectPeriod(shop: HTMLElement, period: string): void {
    shop.querySelectorAll<HTMLButtonElement>('[data-shop-period]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.shopPeriod === period));
    });

    shop.querySelectorAll<HTMLElement>('[data-shop-for-period]').forEach(element => {
        element.hidden = element.dataset.shopForPeriod !== period;
    });

    shop.querySelectorAll<HTMLElement>('[data-shop-plan-periods]').forEach(plan => {
        plan.hidden = !(plan.dataset.shopPlanPeriods ?? '').split('|').includes(period);
    });
}
